import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { PUBLIC_URL } from '../../../config';

const HeroTitle = ({ prize }) => {
    return (
        <Styled.BackgroundImage>
            <Styled.Wrapper>
                <Styled.TextContent>
                    <Styled.Prize
                        src={`${PUBLIC_URL}/img/prize/grand-national-prize.png`}
                        title={`One luck winner will win... ${prize}!`}
                        alt={`One luck winner will win... ${prize}!`}
                    />
                </Styled.TextContent>
            </Styled.Wrapper>
        </Styled.BackgroundImage>
    );
};

HeroTitle.propTypes = {
    prize: PropTypes.string.isRequired
};

export default HeroTitle;
